import { renderSelectLabelLabelTemplate } from '@next-adapter/templates/renderers/generators/columns/column-defs/generate-select-label.js'
export function generateSelectLabel(valueExpression: string): string {
  return renderSelectLabelLabelTemplate({ valueExpression: valueExpression })
}
